// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// hack pro ie11
import hacks            from './model/hacks/hacks'
import consoleExtension from './model/extension/ConsoleExtension'

import Vue          from 'vue'
import Repnode      from './repnode'
import router       from './router'
import store        from './store'
import VueTranslate from 'vue-translate-plugin'
import VueToastr    from '@deveodk/vue-toastr'
import VueCookie    from 'vue-cookie'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import VModal       from 'vue-js-modal'
import Swal         from 'sweetalert2/dist/sweetalert2.js'

// implementace metody Array.includes v ie11
hacks.hackIEArrayIncludes()

// implementace metody Number.format
hacks.hackNumberFormat()

// rozsireni console -> console.dump
consoleExtension.apply()

Vue.config.productionTip = false
Vue.use(VueTranslate)
Vue.use(VueCookie)
Vue.use(VModal)
Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-full-width',
  defaultTimeout:  999999,
  defaultType:     'info'
})

Vue.prototype.$user = store.getters.user

Vue.prototype.cleanSingUp = () => {
  document.body.classList.remove('site-navbar-collapse-show')
  document.body.classList.remove('page-login-v2')
  document.body.classList.remove('page-login-v3')
  document.body.classList.remove('layout-full')
  document.body.classList.remove('page-dark')
}

/**
 * Handle pro rizeni zpracovani chyb pri komunikaci s API
 * @param error
 * @param callback
 * @param generalCallback
 */
Vue.prototype.handleApiError = function (
  error,
  callback        = null,
  generalCallback = null
) {
  let message = '',
      title   = ''

  if (error.response) {
    if (error.response.status === 401) {
      router.params.company
    }

    message = error.response.data.message || error.response.data.error
    title   = error.response.statusText
  }
  else {
    message = error.message
    title   = ''
  }

  if (message === undefined || title === undefined) {
    alert(error)
    return
  }

  if (message.includes('Cannot read properties of undefined')) {
    message = this.$translate.text('err_missing_data')
  }

  Swal
    .fire({
      icon:              'error',
      title:             title,
      text:              message,
      showCloseButton:   true,
      showConfirmButton: false
    })
    .then((result) => {
      if (result.value
        && result.value === true
        && callback instanceof Function) {
        callback()
      }
      if (generalCallback instanceof Function) {
        generalCallback()
      }
    })
}

// spusteni aplikace
/* eslint-disable no-new */
let vueOptions = {
  el:         '#app',
  router,
  store:      store,
  components: { Repnode },
  template:   '<Repnode/>'
}

new Vue(vueOptions)
